import {
  GET_USER_STATUS_DEFINITIONS,
  GET_USER_STATUS_DEFINITIONS_SUCCESS,
  USER_STATUS_DEFINITION_API_ERROR

} from "./actionTypes"


export const getUserStatusDefinitions = () => ({
  type: GET_USER_STATUS_DEFINITIONS,
})

export const getUserStatusDefinitionsSuccess = userStatusDefinition => ({
  type: GET_USER_STATUS_DEFINITIONS_SUCCESS,
  payload: userStatusDefinition,
})

export const userStatusDefinitionsApiError = error => ({
  type: USER_STATUS_DEFINITION_API_ERROR,
  payload: error,
})

